import type {
  CreateCustomerData,
  Customer,
  CustomerType,
  PaymentTerms,
  UpdateCustomerData,
} from '../types/customer';

export const CUSTOMER_TYPES: CustomerType[] = ['RETAIL', 'WHOLESALE', 'CORPORATE', 'GOVERNMENT'];

export const PAYMENT_TERMS: PaymentTerms[] = ['IMMEDIATE', 'NET_30', 'NET_60', 'NET_90'];

export type CustomerFormData = CreateCustomerData;

export const formatCustomerLabel = (value: string) =>
  value
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const defaultCustomerFormData = (options?: { name?: string }): CustomerFormData => ({
  display_name: options?.name?.trim() ?? '',
  email: '',
  phone: '',
  address: '',
  customer_type: 'RETAIL',
  payment_terms: 'IMMEDIATE',
  active: true,
});

export const customerToFormData = (customer: Customer): CustomerFormData => ({
  display_name: customer.display_name,
  email: customer.email ?? '',
  phone: customer.phone ?? '',
  address: customer.address ?? '',
  customer_type: customer.customer_type,
  payment_terms: customer.payment_terms,
  active: customer.active,
});

export const validateCustomerForm = (form: CustomerFormData): Record<string, string[]> | null => {
  const errors: Record<string, string[]> = {};

  if (!form.display_name.trim()) {
    errors.display_name = ['Display name is required.'];
  }

  return Object.keys(errors).length > 0 ? errors : null;
};

export const toCreateCustomerPayload = (form: CustomerFormData): CreateCustomerData => ({
  display_name: form.display_name.trim(),
  email: form.email?.trim() || null,
  phone: form.phone?.trim() || null,
  address: form.address?.trim() || null,
  customer_type: form.customer_type,
  payment_terms: form.payment_terms,
  active: form.active,
});

export const toUpdateCustomerPayload = (form: CustomerFormData): UpdateCustomerData =>
  toCreateCustomerPayload(form);
